module.exports = __webpack_public_path__ + "static/img/wlx-login-bg.f4458e81.png";